import {EntityData} from "@fedeltapointofsale/data-client";

export class CreditCardMappingData extends EntityData<CreditCardMappingData> {
}
